export default "__VITE_ASSET__BUKFaikN__"